import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiGatewayService, RequestParams } from '~app/shared/api-gateway.service';

/**
 * @example
  {
    attributes: [Object],
    DataSource: 'INFO',
    TagName: '30N20CT002:av',
    ShortTagName: '30N20CT002:av',
    Description: 'KPA -KATTILA VERKOSTON PALUUVEDE',
    Department: 'YLLÄS',
    ProcessArea: 'KL',
    ProcessHierarchy: 'YLLÄS/KL',
    Unit: 'mg/m3(n)',
    TagType: 'Analog',
    Min: '0',
    Max: '150',
    MainTagName: '30N20CT002',
    InterpolationMode: 'INTERPOLATED'
  }
*/
export interface ValmetDnaTag {
  attributes: unknown;
  DataSource: string;
  TagName: string;
  ShortTagName: string;
  Description: string;
  Department: string;
  ProcessArea: string;
  ProcessHierarchy: string;
  Unit: string;
  TagType: 'Analog' | string;
  Min: string;
  Max: string;
  MainTagName?: string;
  InterpolationMode: 'INTERPOLATED' | string;
}

/**
 * @example
{
  attributes: [Object],
  ts: '2021-01-11T14:24:01.213+02:00',
  value: '67.14956',
  status: 'Good'
}
 */
export interface ValmetDnaValue {
  attributes: unknown;
  ts: string;
  value: string;
  status: 'Good' | string;
}

interface ValmetTrendResult {
  'Values': ValmetDnaValue | ValmetDnaValue[];
}


interface ValmetTagsResult {
  'Tag': ValmetDnaValue | ValmetDnaTag[];
}

export interface NormalizedTrendResult {
  'Values': ValmetDnaValue[];
}

export interface NormalizedTagsResult {
  'Tag': ValmetDnaTag[];
}

export interface ExceptionResult {
  'Exceptions': {
    Column: string,
    Description: string,
    ExceptionDetails: string,
    TagName?: string
  };
}

interface TrendParams  {
  /**
   * A from date parseable by "new Date()"
   */
  from?: string;
  /**
   * Time period in minutes to query
   */
  period?: string;
}

@Injectable()
export class ValmetDnaService extends ApiGatewayService {
  constructor(protected http: HttpClient) {
    super(http, 'valmet');
  }

  public async getTags(position: string): Promise<NormalizedTagsResult> {
    const result: ValmetTagsResult = await this.get(['positions', position, 'tags']);

    return {
      Tag: this.wrapInArray(result.Tag)
    };
  }

  public async getTrend(position: string, tag: string, params?: TrendParams): Promise<NormalizedTrendResult> {
    const result: ValmetTrendResult = await this.get(['positions', position, 'trends', tag], params as RequestParams);

    return {
      Values: this.wrapInArray(result.Values)
    };
  }

  public async getAlarms(position?: string): Promise<any> {
    if (position === undefined || position === null) {
      return this.get(['alarms']);
    }
    return this.get(['positions', position, 'alarms']);
  }

  private wrapInArray(input: any) {
    if (input === null) {
      return [];
    }
    return Array.isArray(input) ? input : [input];
  }
}
